import { PresentationCoverSlideConfigBodyTextAlignment } from '@/types/schema';

/**
 * Body text alignment for cover/divider slide markdown content. Mirrors
 * the backend `bodyTextAlignment` field on PresentationCoverSlideConfig.
 * Left alignment is the implicit default when no value is set.
 */

// Re-export with a shorter alias for convenience, matching the
// CoverSlideConfigTitleTextSize pattern.
export const CoverSlideConfigBodyTextAlignment =
  PresentationCoverSlideConfigBodyTextAlignment;
export type CoverSlideConfigBodyTextAlignment =
  PresentationCoverSlideConfigBodyTextAlignment;

/** CSS `text-align` value understood by the Lexical theme layer. */
export type BodyTextAlignmentCss = 'center' | 'right';

/**
 * Maps the alignment enum to a CSS `text-align` value. Left is the
 * implicit default, so it (along with null/undefined) maps to undefined —
 * callers then leave the layout untouched and the content stays
 * left-aligned. Only center/right need an explicit override.
 */
export function bodyTextAlignmentToCss(
  alignment?: PresentationCoverSlideConfigBodyTextAlignment | null
): BodyTextAlignmentCss | undefined {
  switch (alignment) {
    case PresentationCoverSlideConfigBodyTextAlignment.CenterAligned:
      return 'center';
    case PresentationCoverSlideConfigBodyTextAlignment.RightAligned:
      return 'right';
    default:
      return undefined;
  }
}
